import { EventEmitter } from '@ssml-editor/modules';
import '../../_virtual/index.js';

const withEvent = (editor) => {
  const newEditor = editor;
  const eventEmitter = new EventEmitter();
  newEditor.on = (event, listener, option) => {
    eventEmitter.on(event, listener, option);
  };
  newEditor.once = (event, listener, option) => {
    eventEmitter.once(event, listener, option);
  };
  newEditor.off = (event, listener) => {
    eventEmitter.off(event, listener);
  };
  newEditor.emit = (event, ...args) => {
    eventEmitter.emit(event, ...args);
  };
  return newEditor;
};

export { withEvent };
//# sourceMappingURL=with-event.js.map
